<!-- 信息收集 -->
<template>
  <div
    class='attendee_form'
    :class="this.$root.isVersion ? 'attendee_form_vers' : ''"
  >
    <div
      class="attendee_form_body"
      :style="{
      padding: `${styleOpt.padding}px`
    }"
    >
      <!-- 顶部图文 -->
      <Prointro
        v-show="isTopText"
        :content="topText"
        :is_collapse="isCollapse"
        :style="{
          borderRadius: `${styleOpt.el_radius}px`,
          marginBottom: `${styleOpt.el_margin}px`
        }"
      />
      <!-- 表单信息 -->
      <Infoform
        :formSty="styleOpt"
        :serveTime="serveTime"
        :footershow="footershow"
      />
      <!-- 说明 -->
      <Explain :formSty="styleOpt" />
    </div>
    <!-- 页面背景 -->
    <div
      class="attendee_form_bgwrap"
      :style="{
        opacity: `${styleOpt.bg_opacity ? styleOpt.bg_opacity  : 1}`,
        backgroundColor:`${ styleOpt.bg_img ? '' : nostyleOpt ? '#f7f8fa' :'var(--bgColor)'}`,
        backgroundImage:`${ styleOpt.bg_img ? 'url('+apiObj.VUE_APP_BASE_CDN +styleOpt.bg_img +')' : ''}`,
      }"
    ></div>
    <!-- 加载中 -->
    <Loading :show="loading" />
  </div>
</template>

<script>

import Prointro from './components/ProIntro'
import Infoform from './components/InfoForm'
import Explain from './components/Explain'
import Loading from '@c/Loading'
import apiObj from '@a/js/api'
import {
  // ObjectDeepClone,
  QicukSort
} from '@/assets/js/utils'
import { GetTicketList } from '@a/js/api/infos'
export default {
  name: 'Form',
  data() {
    return {
      apiObj,
      nostyleOpt: false,
      styleOpt: {
        "layout": "vertical",
        "padding": 8,
        "el_radius": 5,
        "el_margin": 10,
        "button": {
          "redius": 5,
          "text": "支付",
          "bg_color": "#069",
          "color": "#ffffff"
        },
        "bg_img": "",
        "bg_opacity": 1
      },
      fieldsData: {},
      formOptions: [],
      isTopText: false,
      topText: '',
      isCollapse: 1,
      serveTime: '',
      loading: true,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      footershow: true, //显示或者隐藏置底元素,
    };
  },

  components: {
    Prointro,
    Infoform,
    Explain,
    Loading
  },

  methods: {
    // 获取表头配置数组
    GetFormOptionArr(data) {
      return new Promise((resolve) => {
        let tempArr = []
        Object.keys(data).map((item) => {
          // console.log(data[item])
          if (data[item].rank.form.field.isShow) {
            let obj = {
              name: data[item].name,
              label: data[item].label,
              type: data[item].type,
              options: data[item].options,
              placeholder: data[item].placeholder,
              rank: data[item].rank,
            }
            // console.log(obj)
            tempArr.push(obj)
          }


        })
        resolve(tempArr)
      })
    },
    // 对表头数组进行排序
    SortFormHeader(data) {
      return new Promise((resolve) => {
        let sortedFormOption = QicukSort(data, 'form', 'field')
        resolve(sortedFormOption)
      })
    },
    // 获取顶部图文配置
    initProIntro() {
      let data = {
        account_uid: apiObj.VUE_APP_PARAMS.rmb.accountid,
        project_uid: apiObj.VUE_APP_PARAMS.rmb.projectid
      }
      GetTicketList(data).then(res => {
        // console.log(res)
        this.isTopText = res.data.config.is_top_text ? true : false
        this.topText = res.data.config.top_text
        this.isCollapse = res.data.config.is_top_text_collapse
        this.serveTime = res.data.time
        // this.serveTime = new Date('2021-07-05 23:59:59').getTime()
        this.loading = false
      }).catch(() => { })
    },
    getHeight() {
      //实时屏幕高度
      this.showHeight = document.documentElement.clientHeight
      if (this.docmHeight > this.showHeight) {
        this.footershow = false
      } else {
        this.footershow = true
      }
    },
  },

  mounted() {
    window.onresize = () => {
      this.getHeight()
    }
    this.docmHeight = document.documentElement.clientHeight
    this.initProIntro()
  }
}
</script>
<style lang='less' scoped>
.attendee_form {
  position: relative;
  flex: 1;
  box-sizing: border-box;
  height: 100vh;
  /deep/.van-overlay {
    z-index: 100;
  }
  .attendee_form_bgwrap {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-size: 100%;
    z-index: 0;
  }
  .attendee_form_body {
    z-index: 1;
    position: relative;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
  }
}
</style>